import { COURT_STYLE } from '@/domain-ui/court';

export const W = 9;
export const H = 9;
export const TOTAL_H = H * 2;
export const M = 0.5;
export const SERVICE_ZONE_H = 1.5;
export const SERVICE_ZONE_GAP = 0.1;
export const ATTACK_OFFSET = 3;
export const CX = W / 2;
export const CY = TOTAL_H / 2;
export const NET_SNAP = 0.3;

// Habillage repris de `domain-ui/court` : c'est la couleur de CE terrain qui
// fait foi partout (arbitrage n°3), mais elle est désormais déclarée une seule
// fois, avec le filet et les lignes qui vont avec.
export const TEAM_COLOR = COURT_STYLE.surface;
export const ADVERSE_COLOR = TEAM_COLOR;
export const OUTSIDE_COLOR = COURT_STYLE.outside;

export const TARGETING_ACTIONS = ['Attaque', 'Service', 'Retour Direct'];

export type TargetStatus = 'IN' | 'OUT' | 'BLOCKED';

export const STATUS_COLORS: Record<TargetStatus, { fill: string; stroke: string }> = {
  IN: { fill: '#22c55e', stroke: '#16a34a' },
  OUT: { fill: '#ef4444', stroke: '#dc2626' },
  BLOCKED: { fill: '#f97316', stroke: '#ea580c' },
};

/**
 * Statut d'une cible (IN / OUT / BLOCKED) selon l'action et le **côté qui saisit**.
 *
 * Le repère de `y` est physique (positif = moitié « du haut », négatif = moitié
 * « du bas »). Notre équipe (et l'équipe scoutée en une équipe) est rendue en bas
 * et attaque vers le haut : `y > 0` = terrain adverse = IN. En deux équipes, quand
 * l'équipe active est l'adversaire (B, injecté dans la moitié du haut), elle attaque
 * dans l'autre sens : on inverse le signe (`side === 'them'`) pour que viser la
 * moitié du bas devienne IN et viser sa propre moitié devienne BLOCKED.
 */
export function getTargetStatus(
  x: number,
  y: number,
  action: string,
  side: 'us' | 'them' = 'us',
): TargetStatus | null {
  if (action !== 'Attaque' && action !== 'Service' && action !== 'Retour Direct') return null;
  // `yy` = position normalisée « vers l'adversaire du camp qui saisit » (positif = IN).
  const yy = side === 'them' ? -y : y;
  if (yy === 0 || x < 0 || x > W || yy < -H || yy > H) return 'OUT';
  if (yy < 0) return (action === 'Attaque' || action === 'Retour Direct') ? 'BLOCKED' : 'OUT';
  return 'IN';
}

export function inverseRotatePoint(svgX: number, svgY: number, rotation: number): { x: number; y: number } {
  if (rotation === 0) return { x: svgX, y: svgY };
  const rad = (-rotation * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const dx = svgX - CX;
  const dy = svgY - CY;
  return { x: CX + dx * cos - dy * sin, y: CY + dx * sin + dy * cos };
}
